export default "__VITE_ASSET__3Nc132LC__"